export const EXPANDED_SIDEBAR_WIDTH = 220;
export const COLLAPSED_SIDEBAR_WIDTH = 66;
export const NAV_HEIGHT = 64;
export const HEADER_HEIGHT = 56;
export const FILTERS_HEIGHT = 192;
